import "@/lib/handoffToken";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { LanguageProvider } from "@/i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA feature flag (Version 1 = responsive web only). Preserved for later reactivation.
const PWA_ENABLED = process.env.REACT_APP_PWA_ENABLED === "true";

if ("serviceWorker" in navigator) {
  if (PWA_ENABLED) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {});
    });
  } else {
    // Disabled: unregister any stale Rotary service worker and clear its caches safely.
    navigator.serviceWorker.getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister().catch(() => {})))
      .catch(() => {});
    if (window.caches && caches.keys) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k).catch(() => {}))).catch(() => {});
    }
  }
}

if (PWA_ENABLED) {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__bipEvent = e;
    window.dispatchEvent(new Event("pwa-install-ready"));
  });
  window.addEventListener("appinstalled", () => {
    window.__bipEvent = null;
    window.__pwaInstalled = true;
    window.dispatchEvent(new Event("pwa-installed"));
  });
}
